// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scroll-tbody {\n  display: block;\n  max-height: 500px;\n  overflow-y: auto;\n}\n\n.scroll-thead,\n.scroll-tr {\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n}\n\n.value-col {\n  width: 35%;\n}\n", ""]);
// Exports
module.exports = exports;
